module.exports = __webpack_public_path__ + "static/media/aneesh_phatak.9f9d24c8.png";